<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 48 32"
  >
    <g>
      <path
        fill="#4365E2"
        d="M26.524 13.416l-21.999-13.006c-0.438-0.266-0.968-0.424-1.535-0.424-1.651 0-2.99 1.339-2.99 2.99 0 0.005 0 0.011 0 0.016v-0.001 26.005c-0 0.005-0 0.010-0 0.015 0 1.651 1.339 2.99 2.99 2.99 0.567 0 1.097-0.158 1.548-0.431l-0.013 0.008 21.999-12.999c0.892-0.528 1.481-1.486 1.481-2.581s-0.589-2.053-1.467-2.574l-0.014-0.008zM3 28.341v-24.686c0-0 0-0.001 0-0.001 0-0.21 0.17-0.38 0.38-0.38 0.069 0 0.134 0.018 0.19 0.050l-0.002-0.001 20.888 12.35c0.11 0.067 0.183 0.186 0.183 0.322s-0.073 0.256-0.181 0.321l-0.002 0.001-20.888 12.35c-0.054 0.031-0.119 0.050-0.188 0.050-0.208 0-0.377-0.167-0.38-0.375v-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
